<form>
    <label for="input">Output Display Type:</label>
    <Select {items} on:select={handleSelect} on:clear={handleClear}></Select>
</form>

<script>
	import Select from 'svelte-select';

	const items = [
    {value: 'box-plot', label: 'Box Plot'},
		{value: 'iframe', label: 'IFrame'},
		{value: 'images', label: 'Images'},
		{value: 'result-table', label: 'Result Table'},
		{value: 'scatter-plot', label: 'Scatter Plot'},
		{value: 'string', label: 'String'}
	];

	export let value;

	function handleSelect(event) {
		value = event.detail.value;
	}

	function handleClear() {
		value = undefined;
	}
</script>
